<template>
  <div>
    <div class="row">
      <div class="col-12 col-lg-6" v-if="restConfigItems.length">
        <card title="Rest Options">
          <div>
            <fieldset class="form-group">  
              <label>Rest Slides</label>
              <input-asset
                v-model="restSlides"
                defaultCategory="pageBackground"
                :multiple="true"
                requirements="Required dimensions: 3040x1960px<br>Supported formats: jpg, png"
              ></input-asset>
            </fieldset>

            <fieldset class="form-group">
              <label>Rest CTA</label>
              <input v-model="restConfigItems[5].value" class="form-control" type="text" />
            </fieldset>

            <fieldset class="form-group">
              <label>Rest Description</label>
              <ck-editor v-model="restConfigItems[2].value"></ck-editor>
            </fieldset>

            <fieldset class="form-group">
              <label>Rest Company Logo</label>
              <input-asset
                v-model="restConfigItems[3].value"
                defaultCategory="restMedia"
                :multiple="false"
              ></input-asset>
            </fieldset>

            <fieldset class="form-group">
              <label>Rest Development Logo</label>
              <input-asset
                v-model="restConfigItems[4].value"
                defaultCategory="restMedia"
                :multiple="false"
              ></input-asset>
            </fieldset>
          </div>
        </card>
      </div>

      <div class="col-12 col-lg-6" v-if="generalConfigItems.length">
        <card title="General Options">
          <fieldset class="form-group">
            <label>Sidebar Logo</label>
            <input-asset
              v-model="generalConfigItems[1].value"
              defaultCategory="pageSidebar"
              :multiple="false"
            ></input-asset>
          </fieldset>
        </card>
      </div>

      <div class="col-12 col-lg-6" v-if="generalConfigItems.length">
        <card title="Category Selection Options">
          <fieldset class="form-group">
            <label>Category Selection Background</label>
            <input-asset
              v-model="generalConfigItems[0].value"
              defaultCategory="pageBackground"
              :multiple="false"
            ></input-asset>
          </fieldset>
        </card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button @click="updateSettings()" class="btn btn-primary">
          Update Settings
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import {
  CONFIG_ITEMS_EDIT,
  FETCH_CONFIG_ITEMS
} from '@/store/actions.type'
import AssetPreviewBox from '@/components/AssetPreviewBox'
import CkEditor from '@/components/CKEditor'
import InputAsset from '@/components/InputAsset'
import _ from 'lodash'

export default {
  name: 'Settings',

  components: {
    AssetPreviewBox,
    CkEditor,
    InputAsset
  },

  data() {
    return {
      isModalVisible: false,
      modalContext: "",
      modalData: {
        asset: {},
        assetSelected: {
          content: {}
        }
      },

      livingOptionsConfigKeys: [
        "enableLiveHere",
        "liveHereBackground",
        "liveHereDescription",
        "liveHereHeading",
        "liveHereLogo"
      ],
      restConfigKeys: [
        "restType",
        "restMedia",
        "restDescription",
        "restCompanyLogo",
        "restDevelopmentLogo",
        "restCTA"
      ],
      generalConfigKeys: [
        'sidebarLogo',
        'videoWallRest',
        'categorySelectionBackground',
        'categorySelectionBackground2'
      ],

      isModalVisible: false,
      modalContext: ""
    };
  },

  computed: {
    ...mapGetters(["configItems"]),

    livingOptionsConfigItems() {
      return this.configItems.filter(item => {
        return this.livingOptionsConfigKeys.includes(item.key);
      });
    },

    restConfigItems() {
      return this.configItems.filter(item => {
        return this.restConfigKeys.includes(item.key);
      });
    },

    generalConfigItems() {
      return this.configItems.filter(item => {
        return this.generalConfigKeys.includes(item.key)
      })
    },

    restSlides: {
      get: function() {
        if (this.configItems[1]) {
          return this.configItems[1].value
        } else {
          return []
        }
      },

      set: function(newVal) {
        this.configItems[1].value = newVal
      }
    }
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
  },

  async mounted() {
    this.$store.dispatch(FETCH_CONFIG_ITEMS)
      .then(res => {
        if (_.isEmpty(res)) {
          this.$notify({
            message: 'No config items found',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning'
          })
        }
      })
      .catch(err => [
        this.$notify({
          message: "Error retrieving config items - " + err,
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        })
      ]);
  },

  methods: {
    updateSettings() {
      this.$store
        .dispatch(CONFIG_ITEMS_EDIT, this.configItems)
        .then(() => {
          this.$notify({
            message: "Config items successfully updated",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          this.$notify({
            message: "Error updating config items - " + err,
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    },

    closeModal() {
      this.isModalVisible = false;
    },

    setSlideAssetSelected(assetSelected) {
      this.modalData.assetSelected = assetSelected
    },

    openAssetLibrary(context) {
      this.isModalVisible = true;
      this.modalContext = context;
    },

    updateSlides(newSlides) {
      this.restConfigItems[1].value = newSlides;
    },

    openAssetLibrary(context, assetSelected) {
      // defaults
      this.isModalVisible = true;
      this.modalContext = context;
      this.modalData.libraryContext = context;
      this.modalData.libraryCategoryLocked = false;
      this.modalData.assetTarget = assetSelected;

      // context specific
      switch (context) {
        case "backgroundContent":
          this.modalContext = "pageBackground";
          break;

        case "pageSlide":
          this.modalContext = "pageBackground";
          break;

        case "restSlide":
          this.modalContext = "restMedia";
          break;

        default:
          break;
      }
    },

    closeModal() {
      this.isModalVisible = false;
    }
  }
};
</script>
<style></style>
